import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class NotifService {
  private messageService = inject(MessageService);
  private readonly translate = inject(TranslateService);

  info(message: string): void {
    this.messageService.add({
      severity: 'info',
      summary: this.translate.instant('GENERIC.INFO'),
      detail: this.translate.instant(message),
      life: this.duration(message),
    });
  }

  success(message: string): void {
    this.messageService.add({
      severity: 'success',
      summary: this.translate.instant('GENERIC.SUCCESS'),
      detail: this.translate.instant(message),
      life: this.duration(message),
    });
  }

  warn(message: string): void {
    this.messageService.add({
      severity: 'warn',
      summary: this.translate.instant('GENERIC.WARNING'),
      detail: this.translate.instant(message),
      life: this.duration(message),
    });
  }

  error(message: string): void {
    return this.messageService.add({
      severity: 'error',
      summary: this.translate.instant('GENERIC.ERROR'),
      detail: this.translate.instant(message),
      life: this.duration(message),
    });
  }

  // Smart duration of the notification based on message length.
  // The longer the message is the longer the notificaction will remain.
  private duration(message: string): number {
    return Math.min(Math.max(2000, message.length * 75), 10000);
  }
}
